import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Breadcrumb.scss';

const Breadcrumb = (props) => {
    const location = useLocation();
    const state = location.state;

    return (
        <div className='custom-breadcrumb'>
            {props.paths.map((path, index) => (
                <div key={index} className='breadcrumb-item'>
                    {index < props.paths.length - 1 ? (
                        <Link to={{ pathname: path.href, state }}>{path.label}</Link>
                    ) : (
                        <span>{path.label}</span>
                    )}
                </div>
            ))}
        </div>
    );
};

export default Breadcrumb;
